module.exports = __webpack_public_path__ + "6a811c5c672da42f0fc4b118b3bc875c.png";